import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";

interface CardState {
  isCheckoutLoading: boolean;
}

const initialState: CardState = {
  isCheckoutLoading: false,
};

export const checkoutState = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setIsCheckoutLoading: (state, action: PayloadAction<boolean>) => {
      state.isCheckoutLoading = action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.checkout;

export const selectCheckoutIsLoading = createSelector(
  selector,
  (s) => s.isCheckoutLoading
);

export const { setIsCheckoutLoading } = checkoutState.actions;

export default checkoutState.reducer;
